"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcFileDownloadBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var common_constants_1 = require("./../../../common/constants/common-constants");
var bc_file_download_constants_1 = require("./bc-file-download-constants");
var bc_file_download_constants_2 = require("./bc-file-download-constants");
var bc_file_download_constants_3 = require("./bc-file-download-constants");
var bc_file_download_constants_4 = require("./bc-file-download-constants");
var bc_file_download_constants_5 = require("./bc-file-download-constants");
var bc_file_download_constants_6 = require("./bc-file-download-constants");
var bc_file_download_constants_7 = require("./bc-file-download-constants");
var bc_file_download_constants_8 = require("./bc-file-download-constants");
var bc_file_download_constants_9 = require("./bc-file-download-constants");
var bc_file_download_constants_10 = require("./bc-file-download-constants");
var bc_file_download_constants_11 = require("./bc-file-download-constants");
var bc_file_download_constants_12 = require("./bc-file-download-constants");
var bc_file_download_constants_13 = require("./bc-file-download-constants");
var bc_file_download_constants_14 = require("./bc-file-download-constants");
var bc_file_download_constants_15 = require("./bc-file-download-constants");
var bc_file_download_constants_16 = require("./bc-file-download-constants");
var bc_file_download_constants_17 = require("./bc-file-download-constants");
var bc_file_download_constants_18 = require("./bc-file-download-constants");
var bc_file_download_constants_19 = require("./bc-file-download-constants");
var bc_file_download_constants_20 = require("./bc-file-download-constants");
var bc_file_download_constants_21 = require("./bc-file-download-constants");
var bc_file_download_constants_22 = require("./bc-file-download-constants");
var bc_file_download_constants_23 = require("./bc-file-download-constants");
var bc_tooltip_behavior_1 = require("../../molecules/bc-tooltip/bc-tooltip-behavior");
var bc_progress_bar_behavior_1 = require("../../atoms/bc-progress-bar/bc-progress-bar-behavior");
var BcFileDownloadBehavior = (function (_super) {
    __extends(BcFileDownloadBehavior, _super);
    function BcFileDownloadBehavior() {
        var _this = _super.call(this) || this;
        _this.toggleButton = common_constants_1.BcCommonConstants.NULL;
        _this.downloadlist = 1;
        _this.downloadlistSuccess = 0;
        _this.downloadlistSates = bc_file_download_constants_19.FILE_DOWNLOAD_CERO;
        _this.arrayStatus = [];
        _this.progressValue = {};
        _this.allProgressBehavior = {};
        _this.enabledPreloader = false;
        return _this;
    }
    BcFileDownloadBehavior.prototype.setRow = function (index) {
        return "\n        <article class=\"bc-flex-fill bc-d-flex bc-align-items-center bc-p-3\">\n            ".concat(this.getIcons(index), "\n            ").concat(this.getProgressBar(index), "\n            ").concat(this.getDownloadLink(index), "\n            ").concat(this.getRemoveButton(index), "\n        </article>\n    ");
    };
    BcFileDownloadBehavior.prototype.getIcons = function (index) {
        return "\n        <em class=\"bc-icon download-document_".concat(index, " bc-d-none\" aria-hidden=\"true\" role=\"img\">download-document</em>\n        <em class=\"bc-icon successful_").concat(index, " bc-d-none\" aria-hidden=\"true\" role=\"img\">successful</em>\n        <em class=\"bc-icon alert_").concat(index, " bc-d-none\" aria-hidden=\"true\" role=\"img\">alert</em>\n    ");
    };
    BcFileDownloadBehavior.prototype.getProgressBar = function (index) {
        return "\n        <div data-background=\"true\" class=\"progress-bar-download_".concat(index, " bc-flex bc-flex-column bc-w-100\">\n            <div class=\"info bc-px-2 bc-mb-2\">\n                <div class=\"bc-d-flex bc-justify-content-between\">\n                    <section class=\"bc-file-download-content bc-d-flex\">\n                        <p class=\"bc-file-download-labelPre_").concat(index, "\">Generando</p>\n                        <p class=\"bc-file-download-nameFile\"><strong class=\"bc-file-download-filename_").concat(index, "\"></strong></p>\n                        <p class=\"bc-file-download-state bc-file-download-labelPos_").concat(index, "\">generado</p>\n                    </section>\n                    <span class='progress-text_").concat(index, "'>Error al generar el archivo</span>\n                </div>\n            </div>\n            <div\n                id=\"bc-progress-bar_").concat(index, "\"\n                class=\"bc-progress-bar progress_").concat(index, " bc-file-download-progress info bc-px-2 bc-w-100\"\n                type=\"lineal\" value=\"0\" color=\"yellow\" background-color=\"dark\"\n            ></div>\n            <div\n                id=\"bc-preloader_").concat(index, "\"\n                class=\"bc-file-download-preloader bc-preloader preloader_").concat(index, " bc-preloader-line info bc-px-2\"\n                type=\"lineal\" value=\"0\"\n            ></div>\n        </div>\n    ");
    };
    BcFileDownloadBehavior.prototype.getDownloadLink = function (index) {
        return "\n        <a class='bc-file-download-link save-file_".concat(index, "'>\n            <div class='bc-tag-disabled tag-button_").concat(index, "' tabindex='0'>\n                <i class='bc-icon bc-sm bc-mx-1 bc-icon-download_").concat(index, "'>download</i>\n                <p class='bc-mx-1 bc-label-download_").concat(index, " bc-file-download-hiddenLabel'>Descargar</p>\n            </div>\n        </a>\n    ");
    };
    BcFileDownloadBehavior.prototype.getRemoveButton = function (index) {
        return "\n        <section class='bc-file-download-container-remove'>\n            <button\n                class=\"bc-icon-button bc-icon-button".concat(index, " bc-icon-button-solid bc-icon-button-xsmall bc-icon-button-white bc-shadow-02\"\n                aria-label=\"Texto Boton\" tabindex='0'>\n                <i class='bc-icon bc-sm bc-tooltip delete-row_").concat(index, "' bc-tooltip='' bctooltipposition='top' bctooltiptext='Cancelar'>error</i>\n            </button>\n        </section>\n    ");
    };
    BcFileDownloadBehavior.prototype.openAccordion = function () {
        var fileContainer = document.getElementsByClassName(bc_file_download_constants_2.FILE_DOWNLOAD_CONTAINER);
        var container = fileContainer[0];
        if (this._checkCurrentWidth() === bc_file_download_constants_1.FileDownLoadConstants.MOBILE_DEVICE) {
            var bottonMobile = parseInt(this.mySelf.getAttribute(bc_file_download_constants_1.FileDownLoadConstants.DONWLOAD_FILE_DATA_MOBILE));
            container.style.bottom = bottonMobile + common_constants_1.BcCommonConstants.PIXELS;
            var flexError = this.getFirstElementByClassName(common_constants_1.BcCommonConstants.BC_JUSTIFY_CONTENT_BETWEEN);
            flexError.classList.add(common_constants_1.BcCommonConstants.DIRECTION_COLUMN);
        }
        else if (this._checkCurrentWidth() === bc_file_download_constants_1.FileDownLoadConstants.TABLET_DEVICE) {
            var bottonTablet = parseInt(this.mySelf.getAttribute(bc_file_download_constants_1.FileDownLoadConstants.DONWLOAD_FILE_DATA_TABLET));
            container.style.bottom = bottonTablet + common_constants_1.BcCommonConstants.PIXELS;
        }
        var accordion = this.getFirstElementByClassName(bc_file_download_constants_11.FILE_DOWNLOAD_ACCORDION_TYPE);
        accordion.classList.add(bc_file_download_constants_14.FILE_DOWNLOAD_ACCORDION_ACTIVE);
        this.mySelf.classList.remove(bc_file_download_constants_1.FILE_DOWNLOAD_ACCORDION);
    };
    BcFileDownloadBehavior.prototype.showIcon = function (icon, index) {
        var iconDownloading = this.getFirstElementByClassName("".concat(bc_file_download_constants_1.FileDownLoadConstants.DOWNLOAD_DOCUMENT, "_").concat(index));
        var iconSuccess = this.getFirstElementByClassName("".concat(bc_file_download_constants_1.FileDownLoadConstants.SUCCESSFUL_CLASS, "_").concat(index));
        var iconAlert = this.getFirstElementByClassName("".concat(bc_file_download_constants_1.FileDownLoadConstants.ALERT_CLASS, "_").concat(index));
        if (iconDownloading) {
            iconDownloading.style.display = common_constants_1.BcCommonConstants.NONE;
            iconSuccess.style.display = common_constants_1.BcCommonConstants.NONE;
            iconAlert.style.display = common_constants_1.BcCommonConstants.NONE;
            switch (icon) {
                case bc_file_download_constants_1.FileDownLoadConstants.DOWNLOAD_DOCUMENT:
                    iconDownloading.style.display = common_constants_1.BcCommonConstants.BLOCK;
                    break;
                case bc_file_download_constants_1.FileDownLoadConstants.SUCCESSFUL_CLASS:
                    iconSuccess.style.display = common_constants_1.BcCommonConstants.BLOCK;
                    break;
                case bc_file_download_constants_1.FileDownLoadConstants.ALERT_CLASS:
                    iconAlert.style.display = common_constants_1.BcCommonConstants.BLOCK;
                    break;
            }
        }
    };
    BcFileDownloadBehavior.prototype.getFirstElementByClassName = function (className) {
        var elements = this.mySelf.getElementsByClassName(className);
        if (elements.length > bc_file_download_constants_19.FILE_DOWNLOAD_CERO) {
            return elements[bc_file_download_constants_19.FILE_DOWNLOAD_CERO];
        }
        return null;
    };
    BcFileDownloadBehavior.prototype.convertToBinary = function (url, file, fileName) {
        var _this = this;
        if (!fileName) {
            fileName = file.name;
        }
        var reader = new FileReader();
        reader.onload = function () { return __awaiter(_this, void 0, void 0, function () {
            var base64File, base64, fileBlob;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        base64File = reader.result;
                        return [4, fetch(base64File.toString())];
                    case 1:
                        base64 = _a.sent();
                        return [4, base64.blob()];
                    case 2:
                        fileBlob = _a.sent();
                        this.createRow(url, fileBlob, fileName);
                        return [2];
                }
            });
        }); };
        reader.readAsDataURL(file);
    };
    BcFileDownloadBehavior.prototype._checkCurrentWidth = function () {
        var isDevice = '';
        if (window.innerWidth <= bc_file_download_constants_1.FILE_DOWNLOAD_RESOLUTION_MOBILE) {
            isDevice = bc_file_download_constants_1.FileDownLoadConstants.MOBILE_DEVICE;
        }
        else if (window.innerWidth > bc_file_download_constants_1.FILE_DOWNLOAD_RESOLUTION_MOBILE &&
            window.innerWidth <= bc_file_download_constants_1.FILE_DOWNLOAD_RESOLUTION_TABLET) {
            isDevice = bc_file_download_constants_1.FileDownLoadConstants.TABLET_DEVICE;
        }
        return isDevice;
    };
    BcFileDownloadBehavior.prototype.createRow = function (url, blob, fileName) {
        this.fileName = fileName;
        var rowsContainer = this.getFirstElementByClassName(bc_file_download_constants_6.FILE_DOWNLOAD_ROWSCONTAINER);
        var section = document.createElement('section');
        section.innerHTML = this.setRow(this.downloadlist);
        section.classList.add(bc_file_download_constants_3.FILE_DOWNLOAD_ROW);
        section.classList.add("file-download-row_".concat(this.downloadlist));
        rowsContainer.prepend(section);
        if (this.downloadlist > bc_file_download_constants_1.FileDownLoadConstants.MAX_DOWNLOAD_LENGHT) {
            rowsContainer.classList.add(bc_file_download_constants_1.FILE_DOWNLOAD_ROWSCROLL);
            var scroll_1 = this.getFirstElementByClassName(bc_file_download_constants_1.FILE_DOWNLOAD_ROWSCROLL);
            scroll_1.style.height = "".concat(bc_file_download_constants_1.FileDownLoadConstants.FILE_DOWNLOAD_ROWSCROLL_HEIGHT).concat(common_constants_1.BcCommonConstants.PIXELS);
            scroll_1.style.overflow = bc_file_download_constants_1.FileDownLoadConstants.FILE_DOWNLOAD_ROWSCROLL_OVERFLOW;
        }
        this.downloadFile(this.downloadlist, url, blob, fileName);
        this.allProgressBehavior['progress_' + this.downloadlist] = new bc_progress_bar_behavior_1.BcProgressBarBehavior();
        this.allProgressBehavior['progress_' + this.downloadlist].setElement(this.mySelf.querySelector('#bc-progress-bar_' + this.downloadlist));
        this.allProgressBehavior['progress_' + this.downloadlist].setUp();
        this.allProgressBehavior['progress_' + this.downloadlist].setProgress(bc_file_download_constants_1.FileDownLoadConstants.FILE_DOWNLOAD_PROGRESS_INIT);
        this.downloadlist++;
        this.setHeadAccordion();
        this.openAccordion();
        this.showLoader(true);
        this.setUpGeneralCircularProgress();
        this.isBlob(blob);
        bc_tooltip_behavior_1.BcTooltipBehavior.setUpAll();
    };
    BcFileDownloadBehavior.prototype.isBlob = function (blob) {
        if (blob) {
            this.updateTitte(bc_file_download_constants_17.FILE_DOWNLOAD_SUCCESS_MESSAGE_TITLE);
            this.updateSubTitte(null);
            this.showLoader(false);
            this.managerProgressBar(Number(this.downloadlist) - bc_file_download_constants_20.FILE_DOWNLOAD_UNO, null, bc_file_download_constants_1.TEXT_SUCCESS, bc_file_download_constants_19.FILE_DOWNLOAD_CERO);
            this.showIcon(bc_file_download_constants_1.TEXT_SUCCESSFUL, Number(this.downloadlist) - bc_file_download_constants_20.FILE_DOWNLOAD_UNO);
            var progressBarDownload = this.getFirstElementByClassName("progress-bar-download_".concat(Number(this.downloadlist) - bc_file_download_constants_20.FILE_DOWNLOAD_UNO));
            var progressText = this.getFirstElementByClassName("progress-text_".concat(Number(this.downloadlist) - bc_file_download_constants_20.FILE_DOWNLOAD_UNO));
            this.checkPercentComplete(bc_file_download_constants_22.FILE_DOWNLOAD_CIEN, progressText, Number(this.downloadlist) - bc_file_download_constants_20.FILE_DOWNLOAD_UNO, progressBarDownload, null);
            this.allProgressBehavior['progress_' + (Number(this.downloadlist) - bc_file_download_constants_20.FILE_DOWNLOAD_UNO)].setProgress(bc_file_download_constants_22.FILE_DOWNLOAD_CIEN);
        }
    };
    BcFileDownloadBehavior.prototype.downloadFile = function (index, url, blob, fileName) {
        this.managerProgressBar(index, url, bc_file_download_constants_1.FileDownLoadConstants.DOWNLOAD_FILE_STATUS_INIT, bc_file_download_constants_19.FILE_DOWNLOAD_CERO);
        var progressText = this.getFirstElementByClassName("".concat(bc_file_download_constants_1.FileDownLoadConstants.PROGRESS_TEXT_CLASS, "_").concat(index));
        var labelFileName = this.getFirstElementByClassName("".concat(bc_file_download_constants_1.FileDownLoadConstants.FILE_DOWNLOAD_FILENAME_CLASS, "_").concat(index));
        labelFileName.innerHTML = fileName;
        progressText.innerHTML = '';
        if (url) {
            this.eventListener(index, url, fileName);
            this.setNameFile(index, url, fileName);
        }
        if (blob && url === null) {
            if (blob.size) {
                this.setHref(blob, index, fileName);
                this.setNameFile(index, url, fileName);
            }
            else {
                this.managerProgressBar(index, url, 'error', bc_file_download_constants_19.FILE_DOWNLOAD_CERO);
            }
        }
    };
    BcFileDownloadBehavior.prototype.statusRowManager = function (index, valueProgress, progressText, progressBarDownload, url) {
        var preloader = document.getElementById("".concat(bc_file_download_constants_1.FileDownLoadConstants.PRELOADER_CLASS, "_").concat(index));
        var progressBar = document.getElementById("".concat(bc_file_download_constants_1.FileDownLoadConstants.PROGRESS_BAR_CLASS, "_").concat(index));
        var percentComplete = (valueProgress.loaded / valueProgress.total) * bc_file_download_constants_22.FILE_DOWNLOAD_CIEN;
        this.showIcon(bc_file_download_constants_1.FileDownLoadConstants.DOWNLOAD_DOCUMENT, index);
        if (this.enabledPreloader) {
            if (percentComplete === bc_file_download_constants_22.FILE_DOWNLOAD_CIEN) {
                preloader.style.display = common_constants_1.BcCommonConstants.NONE;
                progressBar.style.display = common_constants_1.BcCommonConstants.BLOCK;
                this.stateSuccess(index);
            }
            else {
                preloader.style.display = common_constants_1.BcCommonConstants.BLOCK;
                progressBar.style.display = common_constants_1.BcCommonConstants.NONE;
            }
        }
        else {
            this.calculateGlobalProgress(index);
            this.allProgressBehavior["".concat(bc_file_download_constants_1.FileDownLoadConstants.DOWNLOAD_FILE_STATUS_PROGRESS, "_").concat(index)].setProgress(percentComplete);
            this.checkPercentComplete(percentComplete, progressText, index, progressBarDownload, url);
        }
    };
    BcFileDownloadBehavior.prototype.managerProgressBar = function (index, url, state, valueProgress) {
        var progressText = this.getFirstElementByClassName("progress-text_".concat(index));
        var progressBarDownload = this.getFirstElementByClassName("progress-bar-download_".concat(index));
        this.setStatusDownload(index, state);
        switch (state) {
            case 'init':
                this.stateInit(index);
                break;
            case 'success':
                this.stateSuccess(index);
                break;
            case 'error':
                this.stateError(index, url);
                break;
            case 'progress':
                this.statusRowManager(index, valueProgress, progressText, progressBarDownload, url);
                break;
            default:
                this.stateError(index, url);
                break;
        }
    };
    BcFileDownloadBehavior.prototype.checkPercentComplete = function (percentComplete, progressText, index, progressBarDownload, url) {
        if (!isNaN(percentComplete)) {
            percentComplete = Math.floor(percentComplete);
            progressText.innerHTML = percentComplete + '%';
            if (percentComplete === bc_file_download_constants_22.FILE_DOWNLOAD_CIEN) {
                this.showIcon('successful', index);
                progressBarDownload.classList.remove(bc_file_download_constants_2.FILE_DOWNLOAD_CONTAINER);
                progressBarDownload.classList.remove(bc_file_download_constants_9.FILE_DOWNLOAD_PROGRESS_YELLOW);
                progressBarDownload.classList.add(bc_file_download_constants_10.FILE_DOWNLOAD_PROGRESS_GREEN);
            }
        }
        else {
            this.stateError(index, url);
        }
        return percentComplete;
    };
    BcFileDownloadBehavior.prototype.stateInit = function (index) {
        this.setLabelProgress(index, 'loading');
        this.eventDeleteRow(index);
    };
    BcFileDownloadBehavior.prototype.stateSuccess = function (index) {
        this.showIcon(bc_file_download_constants_1.TEXT_SUCCESSFUL, index);
        var progressText = this.getFirstElementByClassName("progress-text_".concat(index));
        var progressBarDownload = this.getFirstElementByClassName("progress-bar-download_".concat(index));
        if (progressBarDownload) {
            progressBarDownload.classList.add(bc_file_download_constants_10.FILE_DOWNLOAD_PROGRESS_GREEN);
        }
        var progressBarElement = this.allProgressBehavior["".concat(bc_file_download_constants_1.FileDownLoadConstants.DOWNLOAD_FILE_STATUS_PROGRESS, "_").concat(index)];
        progressBarElement.setColor(bc_file_download_constants_1.FileDownLoadConstants.FILE_DOWNLOAD_SUCCESS_COLOR);
        progressBarElement.setProgress(bc_file_download_constants_22.FILE_DOWNLOAD_CIEN);
        progressText.classList.remove(bc_file_download_constants_4.FILE_DOWNLOAD_ERROR);
        progressText.classList.add(bc_file_download_constants_5.FILE_DOWNLOAD_SUCCESS);
    };
    BcFileDownloadBehavior.prototype.stateError = function (index, url) {
        if (url != null) {
            var progress = this.getFirstElementByClassName("progress_".concat(index));
            var progressText = this.getFirstElementByClassName("progress-text_".concat(index));
            var progressBarDownload = this.getFirstElementByClassName("progress-bar-download_".concat(index));
            this.showIcon('alert', index);
            progressText.innerHTML = bc_file_download_constants_18.FILE_DOWNLOAD_ERROR_MESSAGE;
            progressText.classList.remove(bc_file_download_constants_5.FILE_DOWNLOAD_SUCCESS);
            progressText.classList.add(bc_file_download_constants_4.FILE_DOWNLOAD_ERROR);
            progress.setAttribute('value', bc_file_download_constants_22.FILE_DOWNLOAD_CIEN);
            this.clearColorProgressbar(progressBarDownload);
            var rowCount = this.stateRow();
            this.setHeadAccordionError(rowCount);
            this.updatebuttonDownload(index, url, 'refresh', 'Reintentar');
            this.setRowClass(index, bc_file_download_constants_1.FileDownLoadConstants.DOWNLOAD_FILE_STATUS_ERROR);
            this.setLabelProgress(index, bc_file_download_constants_1.FileDownLoadConstants.DOWNLOAD_FILE_STATUS_ERROR);
            this.enableTagButton(index);
            this.allProgressBehavior["".concat(bc_file_download_constants_1.FileDownLoadConstants.DOWNLOAD_FILE_STATUS_PROGRESS, "_").concat(index)].setColor(bc_file_download_constants_1.FileDownLoadConstants.FILE_DOWNLOAD_ERROR_COLOR);
            this.allProgressBehavior["".concat(bc_file_download_constants_1.FileDownLoadConstants.DOWNLOAD_FILE_STATUS_PROGRESS, "_").concat(index)].setProgress(bc_file_download_constants_22.FILE_DOWNLOAD_CIEN);
        }
    };
    BcFileDownloadBehavior.prototype.eventListener = function (index, url, fileName) {
        var _this = this;
        var request = new XMLHttpRequest();
        request.responseType = 'blob';
        request.open('get', url, true);
        request.setRequestHeader('Access-Control-Allow-Headers', '*');
        request.setRequestHeader('Access-Control-Allow-Origin', '*');
        request.send();
        request.onerror = function () {
            _this.managerProgressBar(index, url, 'error', bc_file_download_constants_19.FILE_DOWNLOAD_CERO);
        };
        request.onprogress = function (e) {
            _this.validateOnProgress(request, e, index, url);
        };
        request.onloadend = function (e) {
            if (url) {
                if (request.readyState == bc_file_download_constants_21.FILE_DOWNLOAD_CUATRO &&
                    request.status == bc_file_download_constants_23.FILE_DOWNLOAD_DOSCIENTOS &&
                    e.total > bc_file_download_constants_19.FILE_DOWNLOAD_CERO) {
                    _this.managerProgressBar(index, url, 'success', bc_file_download_constants_19.FILE_DOWNLOAD_CERO);
                    _this.setHref(request.response, index, fileName);
                }
            }
        };
        this.requestEventListener(request, url, index, fileName);
    };
    BcFileDownloadBehavior.prototype.requestEventListener = function (request, url, index, fileName) {
        var _this = this;
        request.addEventListener = function (e) {
            if (url) {
                if (request.readyState == bc_file_download_constants_21.FILE_DOWNLOAD_CUATRO && request.status == bc_file_download_constants_23.FILE_DOWNLOAD_DOSCIENTOS) {
                    _this.managerProgressBar(index, url, 'success', bc_file_download_constants_19.FILE_DOWNLOAD_CERO);
                    _this.setHref(request.response, index, fileName);
                }
                else {
                    _this.managerProgressBar(index, url, 'error', bc_file_download_constants_19.FILE_DOWNLOAD_CERO);
                }
            }
        };
    };
    BcFileDownloadBehavior.prototype.validateOnProgress = function (request, e, index, url) {
        if (request.status == bc_file_download_constants_23.FILE_DOWNLOAD_DOSCIENTOS && e.total > bc_file_download_constants_19.FILE_DOWNLOAD_CERO) {
            this.managerProgressBar(index, url, 'progress', e);
        }
        else {
            this.managerProgressBar(index, url, 'error', bc_file_download_constants_19.FILE_DOWNLOAD_CERO);
        }
    };
    BcFileDownloadBehavior.prototype.setHref = function (blob, index, fileName) {
        var obj = window.URL.createObjectURL(blob);
        var savefileElement = this.getFirstElementByClassName("save-file_".concat(index));
        savefileElement.setAttribute('href', obj);
        if (fileName) {
            savefileElement.setAttribute('download', fileName);
        }
        else {
            savefileElement.setAttribute('download', obj);
        }
        this.setRowClass(index, 'success');
        this.enableTagButton(index);
        this.updatebuttonDownload(index, obj, 'download', 'Descargar');
        this.setHeadAccordion();
        this.setLabelProgress(index, 'loaded');
    };
    BcFileDownloadBehavior.prototype.setHeadAccordion = function () {
        var rowCount = this.stateRow();
        if (this.downloadlistSuccess === rowCount) {
            this.updateTitte(bc_file_download_constants_17.FILE_DOWNLOAD_SUCCESS_MESSAGE_TITLE);
            this.updateSubTitte(null);
            this.showLoader(false);
        }
        else {
            if (rowCount == 1) {
                this.updateTitte("Preparando descarga");
            }
            else if (rowCount > 1) {
                this.updateTitte("Preparando descarga (".concat(this.downloadlistSuccess, " de ").concat(rowCount, ")"));
            }
        }
    };
    BcFileDownloadBehavior.prototype.setHeadAccordionError = function (rowCount) {
        var errorMessage = bc_file_download_constants_16.FILE_DOWNLOAD_ERROR_MESSAGE_SUBTITLE;
        this.updateSubTitte(errorMessage);
        if (this.downloadlist === bc_file_download_constants_20.FILE_DOWNLOAD_UNO) {
            this.updateTitte(bc_file_download_constants_15.FILE_DOWNLOAD_ERROR_MESSAGE_TITTLE);
        }
        this.showLoader(rowCount !== this.downloadlistSates);
    };
    BcFileDownloadBehavior.prototype.setNameFile = function (index, url, name) {
        var labelFileName = this.getFirstElementByClassName("bc-file-download-filename_".concat(index));
        if (url) {
            var arrayUrl = url.split('/');
            var nameFile = arrayUrl[arrayUrl.length - bc_file_download_constants_20.FILE_DOWNLOAD_UNO];
            labelFileName.innerHTML = nameFile;
        }
        if (name) {
            labelFileName.innerHTML = name;
        }
    };
    BcFileDownloadBehavior.prototype.enableTagButton = function (index) {
        var tag = this.getFirstElementByClassName("tag-button_".concat(index));
        tag.classList.remove('bc-tag-disabled');
        tag.classList.add('bc-tag');
    };
    BcFileDownloadBehavior.prototype.clearColorProgressbar = function (element) {
        element.classList.remove('bc-progress-container');
        element.classList.remove('bc-progress-container-green');
        element.classList.remove('bc-progress-container-orange');
    };
    BcFileDownloadBehavior.prototype.eventDeleteRow = function (index) {
        var _this = this;
        var deleteRow = this.getFirstElementByClassName("delete-row_".concat(index));
        var deleteFunc = function () {
            _this.deleteRow(index);
        };
        deleteRow.removeEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, deleteFunc);
        deleteRow.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, deleteFunc);
    };
    BcFileDownloadBehavior.prototype.deleteRow = function (index) {
        var container = this.getFirstElementByClassName(bc_file_download_constants_6.FILE_DOWNLOAD_ROWSCONTAINER);
        var rowIndex = this.getFirstElementByClassName("file-download-row_".concat(index));
        if (rowIndex) {
            container.removeChild(rowIndex);
            this.setStatusDownload(index, 'delete');
        }
        this.setHeadAccordion();
        this.stateRow();
    };
    BcFileDownloadBehavior.prototype.setLabelProgress = function (index, state) {
        var loading = this.getFirstElementByClassName("bc-file-download-labelPre_".concat(index));
        var loaded = this.getFirstElementByClassName("bc-file-download-labelPos_".concat(index));
        switch (state) {
            case 'loading':
                loading.style.display = common_constants_1.BcCommonConstants.BLOCK;
                loaded.style.display = common_constants_1.BcCommonConstants.NONE;
                break;
            case 'loaded':
                loading.style.display = common_constants_1.BcCommonConstants.NONE;
                loaded.style.display = common_constants_1.BcCommonConstants.BLOCK;
                break;
            case 'error':
                loading.style.display = common_constants_1.BcCommonConstants.NONE;
                loaded.style.display = common_constants_1.BcCommonConstants.NONE;
                break;
        }
    };
    BcFileDownloadBehavior.prototype.stateRow = function () {
        var rows = this.mySelf.getElementsByClassName(bc_file_download_constants_3.FILE_DOWNLOAD_ROW);
        if (rows.length === bc_file_download_constants_19.FILE_DOWNLOAD_CERO) {
            this.mySelf.classList.add(bc_file_download_constants_1.FILE_DOWNLOAD_ACCORDION);
        }
        var numSuccess = this.mySelf.getElementsByClassName(bc_file_download_constants_5.FILE_DOWNLOAD_SUCCESS);
        var numError = this.mySelf.getElementsByClassName(bc_file_download_constants_4.FILE_DOWNLOAD_ERROR);
        this.downloadlistSuccess = numSuccess.length;
        this.downloadlistSates = numSuccess.length + numError.length;
        return rows.length;
    };
    BcFileDownloadBehavior.prototype.setRowClass = function (index, result) {
        var row = this.getFirstElementByClassName("file-download-row_".concat(index));
        row.classList.add("bc-download-row-".concat(result));
    };
    BcFileDownloadBehavior.prototype.updateTitte = function (value) {
        var tittle = this.getFirstElementByClassName(bc_file_download_constants_12.FILE_DOWNLOAD_ACCORDION_TITLE);
        tittle.innerHTML = value;
    };
    BcFileDownloadBehavior.prototype.updateSubTitte = function (value) {
        var subTittle = this.getFirstElementByClassName(bc_file_download_constants_13.FILE_DOWNLOAD_ACCORDION_SUBTITLE);
        subTittle.innerHTML = value;
    };
    BcFileDownloadBehavior.prototype.updatebuttonDownload = function (index, url, icon, label) {
        var iconButton = this.getFirstElementByClassName("".concat(bc_file_download_constants_1.FileDownLoadConstants.BC_ICON_BUTTON_DOWNLOAD_CLASS, "_").concat(index));
        var labelButton = this.getFirstElementByClassName("bc-label-download_".concat(index));
        var saveFileButton = this.getFirstElementByClassName("".concat(bc_file_download_constants_1.FileDownLoadConstants.SAVE_FILE_CLASS, "_").concat(index));
        var row = this.getFirstElementByClassName("".concat(bc_file_download_constants_1.FileDownLoadConstants.FILE_DOWNLOAD_ROW_CLASS, "_").concat(index));
        iconButton.innerHTML = icon;
        labelButton.innerHTML = label;
        this.addSaveFileClickListener(saveFileButton, labelButton, index, url);
        this.addRowKeyDownListener(row, labelButton, index, url);
    };
    BcFileDownloadBehavior.prototype.addSaveFileClickListener = function (button, labelButton, index, url) {
        var _this = this;
        button.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            if (labelButton.innerHTML === bc_file_download_constants_1.FileDownLoadConstants.RETRY) {
                _this.downloadFile(index, url, null, _this.fileName);
            }
        });
    };
    BcFileDownloadBehavior.prototype.addRowKeyDownListener = function (row, labelButton, index, url) {
        var _this = this;
        row.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            var focusableElements = [
                _this.getFirstElementByClassName("".concat(bc_file_download_constants_1.FileDownLoadConstants.BC_TAG_BUTTON_CLASS, "_").concat(index)),
                _this.getFirstElementByClassName("".concat(bc_file_download_constants_1.FileDownLoadConstants.BC_ICON_BUTTON_CLASS).concat(index)),
            ];
            var validFocusableElements = focusableElements.filter(function (el) { return el !== null; });
            var currentFocusIndex = validFocusableElements.indexOf(document.activeElement);
            _this.handleKeyBoardEvent(event, labelButton, index, url, validFocusableElements, currentFocusIndex);
        });
    };
    BcFileDownloadBehavior.prototype.handleKeyBoardEvent = function (event, labelButton, index, url, focusableElements, currentFocusIndex) {
        switch (event.key) {
            case common_constants_1.BcCommonConstants.KEY_EVENT_ENTER:
            case common_constants_1.BcCommonConstants.KEY_EVENT_SPACE_CODE:
                this.handleKeyDown(labelButton, index, url);
                break;
            case common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_RIGHT:
                this.moveFocus(focusableElements, currentFocusIndex, 1);
                break;
            case common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_LEFT:
                this.moveFocus(focusableElements, currentFocusIndex, -1);
                break;
            default:
                break;
        }
    };
    BcFileDownloadBehavior.prototype.handleKeyDown = function (labelButton, index, url) {
        var currentLabel = labelButton.innerHTML;
        var tagButton = this.getFirstElementByClassName("".concat(bc_file_download_constants_1.FileDownLoadConstants.BC_TAG_BUTTON_CLASS, "_").concat(index));
        var activeClassName = document.activeElement.className;
        if ((tagButton === null || tagButton === void 0 ? void 0 : tagButton.className) && activeClassName.includes(tagButton.className)) {
            if (currentLabel === bc_file_download_constants_1.FileDownLoadConstants.RETRY) {
                this.downloadFile(index, url, null, this.fileName);
            }
        }
        else if (activeClassName.includes(bc_file_download_constants_1.FileDownLoadConstants.BC_ICON_BUTTON_CLASS)) {
            this.deleteRow(index);
        }
    };
    BcFileDownloadBehavior.prototype.moveFocus = function (focusableElements, currentFocusIndex, direction) {
        var _a;
        if (currentFocusIndex === -1) {
            return;
        }
        var newFocusIndex = (currentFocusIndex + direction + focusableElements.length) % focusableElements.length;
        (_a = focusableElements[newFocusIndex]) === null || _a === void 0 ? void 0 : _a.focus();
    };
    BcFileDownloadBehavior.prototype.showLoader = function (show) {
        var loader = this.getFirstElementByClassName(bc_file_download_constants_7.FILE_DOWNLOAD_LOADER);
        var iconDownload = this.getFirstElementByClassName(bc_file_download_constants_8.FILE_DOWNLOAD_ICON);
        if (show) {
            loader.style.display = common_constants_1.BcCommonConstants.BLOCK;
            iconDownload.style.display = common_constants_1.BcCommonConstants.NONE;
        }
        else {
            loader.style.display = common_constants_1.BcCommonConstants.NONE;
            iconDownload.style.display = common_constants_1.BcCommonConstants.BLOCK;
        }
    };
    BcFileDownloadBehavior.prototype.setStatusDownload = function (index, state) {
        var objectStatus = {};
        objectStatus.index = index;
        objectStatus.state = state;
        var downloadProgress = this.arrayStatus.find(function (element) { return element.index === index; });
        if (downloadProgress) {
            var i = void 0;
            for (i = 0; i < this.arrayStatus.length; i++) {
                if (this.arrayStatus[i].index === index) {
                    this.arrayStatus[i].state = state;
                }
            }
        }
        else {
            this.arrayStatus.push(objectStatus);
        }
        this.emitEvent(this.arrayStatus);
    };
    BcFileDownloadBehavior.prototype.setUpGeneralCircularProgress = function () {
        if (this.generalCircularProgressBehavior) {
            return;
        }
        var loader = this.mySelf.querySelector(".".concat(bc_file_download_constants_7.FILE_DOWNLOAD_LOADER));
        this.generalCircularProgressBehavior = new bc_progress_bar_behavior_1.BcProgressBarBehavior();
        if (this.generalCircularProgressBehavior) {
            this.generalCircularProgressBehavior.setElement(loader);
            this.generalCircularProgressBehavior.setUp();
        }
    };
    BcFileDownloadBehavior.prototype.calculateGlobalProgress = function (index) {
        var rowCount = this.stateRow();
        var rowSuccess = this.downloadlistSates + 1;
        var percent = (rowSuccess / rowCount) * bc_file_download_constants_22.FILE_DOWNLOAD_CIEN;
        this.progressValue["".concat(bc_file_download_constants_1.FileDownLoadConstants.DOWNLOAD_FILE_STATUS_PROGRESS, "_").concat(index)] = percent;
        this.generalCircularProgressBehavior.setProgress(percent);
        if (percent >= bc_file_download_constants_22.FILE_DOWNLOAD_CIEN) {
            this.showLoader(false);
        }
    };
    BcFileDownloadBehavior.prototype.emitEvent = function (arrayStatus) {
        return arrayStatus;
    };
    return BcFileDownloadBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcFileDownloadBehavior = BcFileDownloadBehavior;
